import { RequestService } from '../../../../../common/services/RequestService';
import { SEAT_MATERIALS_GET } from '../../constants';

export const getSeatMaterialsRequest = payload => {
  return RequestService.get(SEAT_MATERIALS_GET);
};
